import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info';
}

export function Badge({ children, variant = 'default' }: BadgeProps) {
  const colorMap: Record<string, { bg: string; text: string }> = {
    default: { bg: 'var(--color-surface-3)', text: 'var(--color-text-primary)' },
    success: { bg: 'rgba(182, 255, 60, 0.1)', text: 'var(--color-success)' },
    warning: { bg: 'rgba(255, 138, 61, 0.1)', text: 'var(--color-warning)' },
    danger: { bg: 'rgba(255, 60, 172, 0.1)', text: 'var(--color-danger)' },
    info: { bg: 'rgba(45, 226, 230, 0.1)', text: 'var(--color-info)' },
  };

  const colors = colorMap[variant];

  return (
    <span
      style={{
        display: 'inline-block',
        backgroundColor: colors.bg,
        color: colors.text,
        padding: 'var(--space-1) var(--space-2)',
        borderRadius: 'var(--radius-sm)',
        fontSize: 'var(--text-xs)',
        fontWeight: 500,
      }}
    >
      {children}
    </span>
  );
}
